import type { MessageDiscussion } from "@/types";
import orderBy from "lodash/orderBy";
import { fromUnixToDate, fromUnixToDateString, isSameDay } from "./date";
import { randUuid } from "./helper";

export function groupMessages(
	messages: MessageDiscussion[],
): MessageDiscussion[] {
	if (!messages.length) return [];
	return orderBy(messages, ["created_at"], ["asc"])
		.map((m, idx) => [idx, m])
		.reduce((acc, item) => {
			const [idx, message] = item as [number, MessageDiscussion];
			const prevMessage = acc[acc.length - 1] as MessageDiscussion;
			const currentMessageCreatedAt = fromUnixToDate(message.created_at);
			const prevMessageCreatedAt = prevMessage
				? fromUnixToDate(prevMessage.created_at)
				: null;

			if (message.documents.length && !message.tags) {
				message.tags = "media";
			}

			if (idx === 0 && !acc.length) {
				acc.push({
					id: randUuid(10),
					text: fromUnixToDateString(message.created_at),
					system_message: true,
					// @ts-expect-error
					tags: "date",
					channel_name: message.channel_name,
					id_db: 0,
					created_at: message.created_at,
					updated_at: message.updated_at,
					document_count: 0,
					document_size: "0.0 Kb",
					sent: false,
					delivered: false,
					strike: false,
					is_deleted: false,
					reply_to: null,
					invitation_status: null,
					latest_reply_date: null,
					reply_count: 0,
					reads: [],
					mention_name: [],
					user: null,
					parent: null,
					replies: [],
					documents: [],
					mentions: [],
					preview: null,
				});
				acc.push(message);
				return acc;
			}
			if (prevMessageCreatedAt && currentMessageCreatedAt) {
				const isInSameDay = isSameDay(
					prevMessageCreatedAt,
					currentMessageCreatedAt,
				);
				if (!isInSameDay) {
					acc.push({
						id: randUuid(10),
						text: fromUnixToDateString(message.created_at),
						system_message: true,
						// @ts-expect-error
						tags: "date",
						channel_name: message.channel_name,
						id_db: 0,
						created_at: message.created_at,
						updated_at: message.updated_at,
						document_count: 0,
						document_size: "0.0 Kb",
						sent: false,
						delivered: false,
						strike: false,
						is_deleted: false,
						reply_to: null,
						invitation_status: null,
						latest_reply_date: null,
						reply_count: 0,
						reads: [],
						mention_name: [],
						user: null,
						parent: null,
						replies: [],
						documents: [],
						mentions: [],
						preview: null,
					});
					acc.push(message);
					return acc;
				}
			}
			acc.push(message);
			return acc;
		}, [] as MessageDiscussion[]) as MessageDiscussion[];
}

export function applyDataChanges<T extends Record<string, any>>(
	origin: T[],
	resUpdate: T[],
	resDelete: T[],
): T[] {
	const filteredOrigin = origin.filter(
		(item) => !resDelete.some((d) => d.id === item.id),
	);
	const updateOrAddMap = new Map(resUpdate.map((item) => [item.id, item]));
	const results = filteredOrigin.map(
		(item) => updateOrAddMap.get(item.id) ?? item,
	);
	for (const item of resUpdate) {
		if (!results.some((existing) => existing.id === item.id)) {
			results.push(item);
		}
	}
	return results;
}
